'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = propsGenerator;


var style = void 0;

var transition = void 0;

function propsGenerator(_ref, _ref2) {
  var startAnimation = _ref.startAnimation,
      startStyle = _ref.startStyle,
      endStyle = _ref.endStyle,
      onCompleteStyle = _ref.onCompleteStyle,
      _ref$durationSeconds = _ref.durationSeconds,
      durationSeconds = _ref$durationSeconds === undefined ? 0.3 : _ref$durationSeconds,
      reverseDelaySeconds = _ref.reverseDelaySeconds,
      delaySeconds = _ref.delaySeconds,
      _ref$easeType = _ref.easeType,
      easeType = _ref$easeType === undefined ? 'linear' : _ref$easeType,
      className = _ref.className,
      transitionValue = _ref.transition,
      refCallback = _ref.refCallback;
  var willEnd = _ref2.willEnd,
      willStart = _ref2.willStart,
      willComplete = _ref2.willComplete,
      willEnter = _ref2.willEnter,
      willLeave = _ref2.willLeave,
      played = _ref2.played;
  var mountProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    willUnmount: false,
    willMount: false
  };
  var willUnmount = mountProps.willUnmount,
      willMount = mountProps.willMount;

  style = startStyle;
  transition = transitionValue || durationSeconds + 's all ' + easeType;

  if (willMount) {
    style = willEnter ? endStyle : startStyle;
  } else if (willUnmount) {
    style = willLeave ? endStyle : startStyle;
  } else if (willComplete && onCompleteStyle) {
    style = onCompleteStyle;
    transition = null;
  } else if (reverseDelaySeconds && !startAnimation && played) {
    style = willStart ? startStyle : endStyle;
  } else if (willEnd || startAnimation && !delaySeconds) {
    style = endStyle;
  }

  return _extends({
    className: className,
    style: _extends(_extends({}, style, {
      transition: transition
    }))
  }, refCallback ? {
    ref: function ref(r) {
      refCallback(r);
    }
  } : null);
}